/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/location';
import '../common/currency';
import './model';
import '../banklin/transaction';
import '../common/time';
import '../banklin/issued_card';
import '../banklin/octopus';
import '../common/instrument';
import '../solidshop/addressVerification/service';
import './unified_activity';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bizbank": {
        "nested": {
          "service": {
            "nested": {
              "CheckIdentityVerificationStatusRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "pollToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CheckIdentityVerificationStatusResponse": {
                "fields": {
                  "pending": {
                    "type": "squareup.bizbank.service.CheckIdentityVerificationStatusResponse.Pending",
                    "id": 1
                  },
                  "response": {
                    "type": "squareup.bizbank.service.CheckIdentityVerificationStatusResponse.Response",
                    "id": 2
                  },
                  "error": {
                    "type": "squareup.bizbank.service.CheckIdentityVerificationStatusResponse.Error",
                    "id": 3
                  }
                },
                "nested": {
                  "Response": {
                    "fields": {
                      "idvState": {
                        "type": "squareup.bizbank.service.IdvState",
                        "id": 1,
                        "rule": "optional"
                      },
                      "idvNeedsSsn": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      },
                      "canRetryIdv": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional"
                      },
                      "idvError": {
                        "type": "squareup.bizbank.service.CheckIdentityVerificationStatusResponse.IdvError",
                        "id": 4,
                        "rule": "optional"
                      },
                      "idvRetriesRemaining": {
                        "type": "int32",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  },
                  "Pending": {
                    "fields": {
                      "pollToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "IdvError": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "TOO_MANY_ATTEMPTS": 3,
                      "UNDER_AGE_OF_MAJORITY": 4,
                      "DOES_NOT_MATCH": 5
                    }
                  },
                  "Error": {
                    "fields": {
                      "reason": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "result": {
                    "oneof": ["pending", "response", "error"]
                  }
                }
              },
              "ConfirmIssueCardRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardIssueToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "shippingAddress": {
                    "type": "squareup.common.location.GlobalAddress",
                    "id": 3,
                    "rule": "optional"
                  },
                  "customizationToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "sourceApplication": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "shouldPauseDeposits": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "ConfirmIssueCardResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "canImmediatelyAddToWallet": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "cardData": {
                    "type": "squareup.bizbank.service.CardData",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "CreateCardCustomizationRequest": {
                "fields": {
                  "idempotenceKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "imageBytes": {
                    "type": "bytes",
                    "id": 3,
                    "rule": "optional"
                  },
                  "mimeType": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "existingTrunkToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "CreateCardCustomizationResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cutomizationToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "DeactivateCardRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "deactivationReason": {
                    "type": "squareup.bizbank.service.DeactivateCardRequest.DeactivationReason",
                    "id": 3,
                    "rule": "optional"
                  },
                  "sourceApplication": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "DeactivationReason": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "LOST": 1,
                      "STOLEN": 2,
                      "CARD_NOT_RECEIVED": 3,
                      "CANCEL": 4,
                      "FRAUD": 5,
                      "TRANSFER_OF_ACCOUNT": 6,
                      "RISK_ACCOUNT_DEACTIVATION": 7
                    }
                  }
                }
              },
              "DeactivateCardResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "bizbankEnabled": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "FinishCardActivationRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "activationToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cvv": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "expirationMmyy": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "fideliusToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "sourceApplication": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "cardToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "FinishCardActivationResponse": {
                "fields": {
                  "result": {
                    "type": "squareup.bizbank.service.FinishCardActivationResponse.Result",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "pinIsSet": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Result": {
                    "values": {
                      "SUCCESS": 1,
                      "FAILED": 2,
                      "ACTIVATION_TOKEN_INVALID": 3,
                      "ACTIVATION_TOKEN_EXPIRED": 4,
                      "INCORRECT_CVV": 5,
                      "INCORRECT_EXPIRATION": 6,
                      "INCORRECT_CARD_INFO": 7
                    }
                  }
                }
              },
              "GetBalanceRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetBalanceResponse": {
                "fields": {
                  "balance": {
                    "type": "squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "maxInstantDepositAmount": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "pendingBalance": {
                    "type": "squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "GetCardActivityRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "batchRequest": {
                    "type": "squareup.bizbank.model.BatchRequest",
                    "id": 2,
                    "rule": "optional"
                  },
                  "filters": {
                    "type": "squareup.bizbank.service.GetCardActivityRequest.Filters",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Filters": {
                    "fields": {
                      "includeStates": {
                        "type": "squareup.banklin.TransactionState",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "excludeStates": {
                        "type": "squareup.banklin.TransactionState",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "minOccurredAt": {
                        "type": "squareup.common.time.DateTime",
                        "id": 3,
                        "rule": "optional"
                      },
                      "maxOccurredAt": {
                        "type": "squareup.common.time.DateTime",
                        "id": 4,
                        "rule": "optional"
                      },
                      "excludeActivityTypes": {
                        "type": "squareup.bizbank.service.CardActivity.ActivityType",
                        "id": 5,
                        "rule": "repeated"
                      },
                      "includeActivityTypes": {
                        "type": "squareup.bizbank.service.CardActivity.ActivityType",
                        "id": 6,
                        "rule": "repeated"
                      },
                      "dateSource": {
                        "type": "squareup.bizbank.service.GetCardActivityRequest.Filters.DateSource",
                        "id": 7,
                        "rule": "optional",
                        "options": {
                          "default": "OCCURRED_AT"
                        }
                      }
                    },
                    "nested": {
                      "DateSource": {
                        "values": {
                          "OCCURRED_AT": 1,
                          "UPDATED_AT": 2
                        }
                      }
                    }
                  }
                }
              },
              "GetCardActivityResponse": {
                "fields": {
                  "transactionEvents": {
                    "type": "squareup.banklin.TransactionEvent",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "cardActivity": {
                    "type": "squareup.bizbank.service.CardActivity",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "batchResponse": {
                    "type": "squareup.bizbank.service.GetCardActivityResponse.BatchResponse",
                    "id": 2,
                    "rule": "optional"
                  },
                  "fetchedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  },
                  "balance": {
                    "type": "squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "maxInstantDepositAmount": {
                    "type": "squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "BatchResponse": {
                    "fields": {
                      "nextPaginationToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "GetCardCustomizationRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1
                  },
                  "customizationToken": {
                    "type": "string",
                    "id": 2
                  }
                },
                "nested": {
                  "token": {
                    "oneof": ["unitToken", "customizationToken"]
                  }
                }
              },
              "CardCustomization": {
                "fields": {
                  "imageBytes": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "optional"
                  },
                  "mimeType": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetCardCustomizationResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "businessName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cardCustomization": {
                    "type": "squareup.bizbank.service.CardCustomization",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "GetCardBillingAddressRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetCardBillingAddressResponse": {
                "fields": {
                  "billingAddress": {
                    "type": "squareup.common.location.GlobalAddress",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ListCardsRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "includeAdditionalDetails": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "filters": {
                    "type": "squareup.bizbank.service.ListCardsRequest.Filters",
                    "id": 3,
                    "rule": "optional"
                  },
                  "sortOrder": {
                    "type": "squareup.bizbank.service.ListCardsRequest.SortOrder",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": "ASC"
                    }
                  }
                },
                "nested": {
                  "SortOrder": {
                    "values": {
                      "ASC": 1,
                      "DESC": 2
                    }
                  },
                  "Filters": {
                    "fields": {
                      "includedCardTypes": {
                        "type": "squareup.bizbank.service.CardData.CardType",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              },
              "ListCardsResponse": {
                "fields": {
                  "cards": {
                    "type": "squareup.bizbank.service.CardData",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "CardBrand": {
                "values": {
                  "VISA": 1,
                  "MASTERCARD": 2
                }
              },
              "CardData": {
                "fields": {
                  "cardToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "banklinCardToken": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "cardState": {
                    "type": "squareup.bizbank.service.CardData.CardState",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cardBrand": {
                    "type": "squareup.bizbank.service.CardBrand",
                    "id": 3,
                    "rule": "optional"
                  },
                  "panLastFour": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "nameOnCard": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "active2faTokenTypes": {
                    "type": "squareup.bizbank.service.TwoFactorAuthenticationRequestType",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "shippingAddress": {
                    "type": "squareup.common.location.GlobalAddress",
                    "id": 7,
                    "rule": "optional"
                  },
                  "billingAddress": {
                    "type": "squareup.common.location.GlobalAddress",
                    "id": 8,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 9,
                    "rule": "optional"
                  },
                  "cardType": {
                    "type": "squareup.bizbank.service.CardData.CardType",
                    "id": 10,
                    "rule": "optional"
                  },
                  "deactivationReason": {
                    "type": "squareup.bizbank.service.DeactivateCardRequest.DeactivationReason",
                    "id": 11,
                    "rule": "optional"
                  },
                  "cardEvents": {
                    "type": "squareup.banklin.CardEvent",
                    "id": 12,
                    "rule": "repeated"
                  },
                  "isActivatable": {
                    "type": "bool",
                    "id": 13,
                    "rule": "optional"
                  },
                  "customizationToken": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "CardState": {
                    "values": {
                      "ACTIVE": 1,
                      "DISABLED": 2,
                      "TERMINATED": 3,
                      "SUSPENDED": 4,
                      "VERIFIED": 5,
                      "ISSUED": 6,
                      "UNDELIVERABLE": 7,
                      "SHIPPED": 8,
                      "CANCELLED": 9,
                      "REJECTED": 10,
                      "DESTROYED": 11,
                      "ACTIVE_PENDING_2FA": 12,
                      "REVIEW_PENDING": 13,
                      "CUSTOMIZATION_APPROVED": 14,
                      "CUSTOMIZATION_DENIED": 15
                    }
                  },
                  "CardType": {
                    "values": {
                      "PHYSICAL": 1,
                      "VIRTUAL": 2
                    }
                  }
                }
              },
              "CardActivity": {
                "fields": {
                  "transactionToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "activityType": {
                    "type": "squareup.bizbank.service.CardActivity.ActivityType",
                    "id": 4,
                    "rule": "optional"
                  },
                  "transactionState": {
                    "type": "squareup.banklin.TransactionState",
                    "id": 5,
                    "rule": "optional"
                  },
                  "occurredAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 6,
                    "rule": "optional"
                  },
                  "activityDisplayString": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "paginationToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "declineReason": {
                    "type": "squareup.banklin.octopus.OctopusResult",
                    "id": 12,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 13,
                    "rule": "optional"
                  },
                  "moneyTransferServerToken": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "cardInfo": {
                    "type": "squareup.bizbank.service.CardActivity.DepositCardInfo",
                    "id": 9
                  },
                  "bankInfo": {
                    "type": "squareup.bizbank.service.CardActivity.DepositBankInfo",
                    "id": 10
                  }
                },
                "nested": {
                  "ActivityType": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "CARD_PAYMENT": 1,
                      "DEPOSIT": 2,
                      "INSTANT_DEPOSIT": 3,
                      "INSTANT_DEPOSIT_FEE": 4,
                      "ATM_WITHDRAWAL": 5,
                      "ATM_WITHDRAWAL_FEE": 6,
                      "CARD_PAYMENT_REWARD": 7
                    }
                  },
                  "DepositCardInfo": {
                    "fields": {
                      "cardBrand": {
                        "type": "squareup.common.instrument.InstrumentType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "panSuffix": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "cardToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "DepositBankInfo": {
                    "fields": {
                      "bankName": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "bankAccountSuffix": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "bankAccountToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "deposit_info": {
                    "oneof": ["cardInfo", "bankInfo"]
                  }
                }
              },
              "ProvideFeedbackRequest": {
                "fields": {
                  "idempotenceKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "feedbackText": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "feedbackSource": {
                    "type": "squareup.bizbank.service.ProvideFeedbackRequest.FeedbackSource",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "FeedbackSource": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "CARD_DEACTIVATION": 1,
                      "BALANCE_DEACTIVATION": 2,
                      "ACCOUNT_DEACTIVATION_REGULATOR": 3,
                      "TRANSFER_OF_ACCOUNT": 4,
                      "ADMIN_CONSOLE": 5,
                      "ACCOUNT_DEACTIVATION_BANK_PARTNER": 6,
                      "ACCOUNT_DEACTIVATION_RISK_TEAM": 7
                    }
                  }
                }
              },
              "ProvideFeedbackResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "SetCardBillingAddressRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "billingAddress": {
                    "type": "squareup.common.location.GlobalAddress",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "SetCardBillingAddressResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "SetEnabledRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "enabled": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "SetEnabledResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "SetPasscodeRequest": {
                "fields": {
                  "passcode": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cardToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "authenticationToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "sourceApplication": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "SetPasscodeResponse": {
                "fields": {
                  "result": {
                    "type": "squareup.bizbank.service.SetPasscodeResponse.Result",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Result": {
                    "values": {
                      "SUCCESS": 1,
                      "FAILED": 2,
                      "INVALID_CARD_TOKEN": 3,
                      "FAILED_WEAK_PASSCODE": 4,
                      "AUTHENTICATION_TOKEN_INVALID": 5,
                      "AUTHENTICATION_TOKEN_EXPIRED": 6
                    }
                  }
                }
              },
              "StartCardActivationRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "StartCardActivationResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "StartIdentityVerificationRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "ownerAddress": {
                    "type": "squareup.common.location.GlobalAddress",
                    "id": 2,
                    "rule": "optional"
                  },
                  "ownerBirthDate": {
                    "type": "squareup.common.time.YearMonthDay",
                    "id": 3,
                    "rule": "optional"
                  },
                  "ownerSocialSecurityNumber": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "StartIdentityVerificationResponse": {
                "fields": {
                  "pollToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "StartIssueCardRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "shippingAddress": {
                    "type": "squareup.common.location.GlobalAddress",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "StartIssueCardResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cardIssueToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "normalizedAddress": {
                    "type": "squareup.common.location.GlobalAddress",
                    "id": 4,
                    "rule": "optional"
                  },
                  "addressNormalizationResult": {
                    "type": "squareup.bizbank.service.StartIssueCardResponse.AddressNormalizationResult",
                    "id": 5,
                    "rule": "optional"
                  },
                  "correctedField": {
                    "type": "squareup.solidshop.VerifyShippingAddressResponse.CorrectedField",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "challengeRequested": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                },
                "nested": {
                  "AddressNormalizationResult": {
                    "values": {
                      "SUCCESS": 1,
                      "VERIFICATION_NOT_AVAILABLE": 2,
                      "VERIFICATION_FAILED": 3,
                      "UNKNOWN_ERROR": 4
                    }
                  }
                }
              },
              "TwoFactorAuthenticationRequestType": {
                "values": {
                  "DO_NOT_USE": 0,
                  "CARD_ACTIVATION": 1,
                  "RESET_PASSCODE": 2,
                  "SHOW_PRIVATE_CARD_DATA": 3,
                  "SHOW_DIRECT_DEPOSIT_ACCOUNT": 4
                }
              },
              "StartTwoFactorAuthenticationRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "requestType": {
                    "type": "squareup.bizbank.service.TwoFactorAuthenticationRequestType",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "StartTwoFactorAuthenticationResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ToggleCardRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "enableCard": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "sourceApplication": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "ToggleCardResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "card": {
                    "type": "squareup.bizbank.service.CardData",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "VerifyCardActivationTokenRequest": {
                "fields": {
                  "activationToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "VerifyCardActivationTokenResponse": {
                "fields": {
                  "result": {
                    "type": "squareup.bizbank.service.VerifyCardActivationTokenResponse.Result",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Result": {
                    "values": {
                      "VERIFIED": 1,
                      "INVALID_TOKEN": 2,
                      "EXPIRED_TOKEN": 3,
                      "USED": 4,
                      "FAILED": 5
                    }
                  }
                }
              },
              "VerifyTwoFactorAuthenticationTokenRequest": {
                "fields": {
                  "authenticationToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "requestType": {
                    "type": "squareup.bizbank.service.TwoFactorAuthenticationRequestType",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "VerifyTwoFactorAuthenticationTokenResponse": {
                "fields": {
                  "result": {
                    "type": "squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenResponse.Result",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Result": {
                    "values": {
                      "VERIFIED": 1,
                      "INVALID_TOKEN": 2,
                      "EXPIRED_TOKEN": 3
                    }
                  }
                }
              },
              "IdvState": {
                "values": {
                  "IDV_DO_NOT_USE": 0,
                  "APPROVED": 1,
                  "INCOMPLETE": 2
                }
              },
              "ValidateAddressRequest": {
                "fields": {
                  "address": {
                    "type": "squareup.common.location.GlobalAddress",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ValidateAddressResponse": {
                "fields": {
                  "normalizedAddress": {
                    "type": "squareup.common.location.GlobalAddress",
                    "id": 1,
                    "rule": "optional"
                  },
                  "addressNormalizationResult": {
                    "type": "squareup.bizbank.service.ValidateAddressResponse.AddressNormalizationResult",
                    "id": 2,
                    "rule": "optional"
                  },
                  "correctedFields": {
                    "type": "squareup.bizbank.service.ValidateAddressResponse.CorrectedField",
                    "id": 3,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "CorrectedField": {
                    "values": {
                      "DO_NOT_USE_FIELD": 0,
                      "ADDRESS_LINE_1": 1,
                      "ADDRESS_LINE_2": 2,
                      "ADMINISTRATIVE_DISTRICT_LEVEL_1": 3,
                      "LOCALITY": 4,
                      "POSTAL_CODE": 5
                    }
                  },
                  "AddressNormalizationResult": {
                    "values": {
                      "DO_NOT_USE_RESULT": 0,
                      "SUCCESS": 1,
                      "VERIFICATION_NOT_AVAILABLE": 2,
                      "VERIFICATION_FAILED": 3,
                      "UNKNOWN_ERROR": 4
                    }
                  }
                }
              },
              "GetCustomizationSettingsRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "userAgent": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetCustomizationSettingsResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "ownerName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "businessName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "minInkCoverage": {
                    "type": "float",
                    "id": 4,
                    "rule": "optional"
                  },
                  "maxInkCoverage": {
                    "type": "float",
                    "id": 5,
                    "rule": "optional"
                  },
                  "idvState": {
                    "type": "squareup.bizbank.service.IdvState",
                    "id": 6,
                    "rule": "optional"
                  },
                  "canRetryIdv": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "ownerAddress": {
                    "type": "squareup.common.location.GlobalAddress",
                    "id": 8,
                    "rule": "optional"
                  },
                  "ownerBirthDate": {
                    "type": "squareup.common.time.YearMonthDay",
                    "id": 9,
                    "rule": "optional"
                  },
                  "idvNeedsSsn": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "idvRetriesRemaining": {
                    "type": "int32",
                    "id": 11,
                    "rule": "optional"
                  },
                  "ineligibilityReason": {
                    "type": "squareup.bizbank.service.GetCustomizationSettingsResponse.IneligibilityReason",
                    "id": 12,
                    "rule": "optional"
                  },
                  "existingCustomization": {
                    "type": "squareup.bizbank.service.GetCustomizationSettingsResponse.ExistingCustomization",
                    "id": 13,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "IneligibilityReason": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "NOT_ELIGIBLE": 1,
                      "EXHAUSTED_IDV_RETRIES": 2,
                      "NOT_ACTIVATED": 3
                    }
                  },
                  "ExistingCustomization": {
                    "fields": {
                      "trunkToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "imageBytes": {
                        "type": "bytes",
                        "id": 2,
                        "rule": "optional"
                      },
                      "mimeType": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "GetAllStampsRequest": {
                "fields": {}
              },
              "GetAllStampsResponse": {
                "fields": {
                  "stamps": {
                    "type": "squareup.bizbank.service.Stamp",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "Stamp": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "accessibilityText": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "svg": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "minScale": {
                    "type": "int32",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "MerchantBlockState": {
                "values": {
                  "UNKNOWN_MERCHANT_BLOCK_STATE": 0,
                  "BLOCKED": 1,
                  "UNBLOCKED": 2
                }
              },
              "UpdateMerchantBlockRequest": {
                "fields": {
                  "merchanteinMerchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "merchantBlockState": {
                    "type": "squareup.bizbank.service.MerchantBlockState",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "UpdateMerchantBlockResponse": {
                "fields": {
                  "merchantBlockState": {
                    "type": "squareup.bizbank.service.MerchantBlockState",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetMerchantBlockRequest": {
                "fields": {
                  "merchanteinMerchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetMerchantBlockResponse": {
                "fields": {
                  "merchantBlockState": {
                    "type": "squareup.bizbank.service.MerchantBlockState",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ListMerchantBlocksRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ListMerchantBlocksResponse": {
                "fields": {
                  "blockedMerchanteinMerchants": {
                    "type": "squareup.bizbank.service.ListMerchantBlocksResponse.MerchanteinMerchant",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "MerchanteinMerchant": {
                    "fields": {
                      "token": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "name": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "merchantImage": {
                        "type": "squareup.bizbank.unified_activity.UnifiedActivity.MerchantImage",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CheckIdentityVerificationStatusRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CheckIdentityVerificationStatusResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CheckIdentityVerificationStatusResponse?.nested?.Response && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CheckIdentityVerificationStatusResponse?.nested?.Pending && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CheckIdentityVerificationStatusResponse?.nested?.IdvError && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CheckIdentityVerificationStatusResponse?.nested?.Error && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ConfirmIssueCardRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ConfirmIssueCardResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CreateCardCustomizationRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CreateCardCustomizationResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.DeactivateCardRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.DeactivateCardRequest?.nested?.DeactivationReason && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.DeactivateCardResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.FinishCardActivationRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.FinishCardActivationResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.FinishCardActivationResponse?.nested?.Result && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetBalanceRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetBalanceResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardActivityRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardActivityRequest?.nested?.Filters && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardActivityRequest?.nested?.Filters?.nested?.DateSource && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardActivityResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardActivityResponse?.nested?.BatchResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardCustomizationRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardCustomization && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardCustomizationResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardBillingAddressRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardBillingAddressResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListCardsRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListCardsRequest?.nested?.SortOrder && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListCardsRequest?.nested?.Filters && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListCardsResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardBrand && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardData && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardData?.nested?.CardState && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardData?.nested?.CardType && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardActivity && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardActivity?.nested?.ActivityType && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardActivity?.nested?.DepositCardInfo && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardActivity?.nested?.DepositBankInfo && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvideFeedbackRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvideFeedbackRequest?.nested?.FeedbackSource && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvideFeedbackResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetCardBillingAddressRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetCardBillingAddressResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetEnabledRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetEnabledResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetPasscodeRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetPasscodeResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetPasscodeResponse?.nested?.Result && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartCardActivationRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartCardActivationResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartIdentityVerificationRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartIdentityVerificationResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartIssueCardRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartIssueCardResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartIssueCardResponse?.nested?.AddressNormalizationResult && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.TwoFactorAuthenticationRequestType && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartTwoFactorAuthenticationRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartTwoFactorAuthenticationResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ToggleCardRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ToggleCardResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VerifyCardActivationTokenRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VerifyCardActivationTokenResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VerifyCardActivationTokenResponse?.nested?.Result && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VerifyTwoFactorAuthenticationTokenRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VerifyTwoFactorAuthenticationTokenResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VerifyTwoFactorAuthenticationTokenResponse?.nested?.Result && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.IdvState && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ValidateAddressRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ValidateAddressResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ValidateAddressResponse?.nested?.CorrectedField && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ValidateAddressResponse?.nested?.AddressNormalizationResult && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCustomizationSettingsRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCustomizationSettingsResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCustomizationSettingsResponse?.nested?.IneligibilityReason && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCustomizationSettingsResponse?.nested?.ExistingCustomization && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetAllStampsRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetAllStampsResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.Stamp && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.MerchantBlockState && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.UpdateMerchantBlockRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.UpdateMerchantBlockResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetMerchantBlockRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetMerchantBlockResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListMerchantBlocksRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListMerchantBlocksResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListMerchantBlocksResponse?.nested?.MerchanteinMerchant) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CheckIdentityVerificationStatusRequest @ squareup/bizbank/service.proto at 65:1
 */
export const CheckIdentityVerificationStatusRequest = $root.lookupType('squareup.bizbank.service.CheckIdentityVerificationStatusRequest');
fixType(CheckIdentityVerificationStatusRequest, {
  unitToken: {
    required: true
  }
});
Builder.createAndAttachToType(CheckIdentityVerificationStatusRequest);
/**
 * SOURCE CheckIdentityVerificationStatusResponse @ squareup/bizbank/service.proto at 70:1
 */
export const CheckIdentityVerificationStatusResponse = $root.lookupType('squareup.bizbank.service.CheckIdentityVerificationStatusResponse');
fixType(CheckIdentityVerificationStatusResponse);
Builder.createAndAttachToType(CheckIdentityVerificationStatusResponse);
/**
 * SOURCE Response @ squareup/bizbank/service.proto at 71:3
 */
CheckIdentityVerificationStatusResponse.Response = $root.lookupType('squareup.bizbank.service.CheckIdentityVerificationStatusResponse.Response');
fixType(CheckIdentityVerificationStatusResponse.Response);
Builder.createAndAttachToType(CheckIdentityVerificationStatusResponse.Response);
/**
 * SOURCE Pending @ squareup/bizbank/service.proto at 82:3
 */
CheckIdentityVerificationStatusResponse.Pending = $root.lookupType('squareup.bizbank.service.CheckIdentityVerificationStatusResponse.Pending');
fixType(CheckIdentityVerificationStatusResponse.Pending);
Builder.createAndAttachToType(CheckIdentityVerificationStatusResponse.Pending);
/**
 * SOURCE IdvError @ squareup/bizbank/service.proto at 86:3
 */
CheckIdentityVerificationStatusResponse.IdvError = $root.lookupEnum('squareup.bizbank.service.CheckIdentityVerificationStatusResponse.IdvError').values;
/**
 * SOURCE Error @ squareup/bizbank/service.proto at 94:3
 */
CheckIdentityVerificationStatusResponse.Error = $root.lookupType('squareup.bizbank.service.CheckIdentityVerificationStatusResponse.Error');
fixType(CheckIdentityVerificationStatusResponse.Error);
Builder.createAndAttachToType(CheckIdentityVerificationStatusResponse.Error);
/**
 * SOURCE ConfirmIssueCardRequest @ squareup/bizbank/service.proto at 106:1
 */
export const ConfirmIssueCardRequest = $root.lookupType('squareup.bizbank.service.ConfirmIssueCardRequest');
fixType(ConfirmIssueCardRequest, {
  unitToken: {
    notEmpty: true
  },
  cardIssueToken: {
    notEmpty: true
  },
  shippingAddress: {
    required: true
  }
});
Builder.createAndAttachToType(ConfirmIssueCardRequest);
/**
 * SOURCE ConfirmIssueCardResponse @ squareup/bizbank/service.proto at 121:1
 */
export const ConfirmIssueCardResponse = $root.lookupType('squareup.bizbank.service.ConfirmIssueCardResponse');
fixType(ConfirmIssueCardResponse, {
  success: {
    required: true
  }
});
Builder.createAndAttachToType(ConfirmIssueCardResponse);
/**
 * SOURCE CreateCardCustomizationRequest @ squareup/bizbank/service.proto at 156:1
 */
export const CreateCardCustomizationRequest = $root.lookupType('squareup.bizbank.service.CreateCardCustomizationRequest');
fixType(CreateCardCustomizationRequest, {
  idempotenceKey: {
    notEmpty: true
  },
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreateCardCustomizationRequest);
/**
 * SOURCE CreateCardCustomizationResponse @ squareup/bizbank/service.proto at 165:1
 */
export const CreateCardCustomizationResponse = $root.lookupType('squareup.bizbank.service.CreateCardCustomizationResponse');
fixType(CreateCardCustomizationResponse, {
  success: {
    required: true
  }
});
Builder.createAndAttachToType(CreateCardCustomizationResponse);
/**
 * SOURCE DeactivateCardRequest @ squareup/bizbank/service.proto at 170:1
 */
export const DeactivateCardRequest = $root.lookupType('squareup.bizbank.service.DeactivateCardRequest');
fixType(DeactivateCardRequest, {
  unitToken: {
    notEmpty: true
  },
  cardToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(DeactivateCardRequest);
/**
 * SOURCE DeactivationReason @ squareup/bizbank/service.proto at 171:3
 */
DeactivateCardRequest.DeactivationReason = $root.lookupEnum('squareup.bizbank.service.DeactivateCardRequest.DeactivationReason').values;
/**
 * SOURCE DeactivateCardResponse @ squareup/bizbank/service.proto at 188:1
 */
export const DeactivateCardResponse = $root.lookupType('squareup.bizbank.service.DeactivateCardResponse');
fixType(DeactivateCardResponse, {
  success: {
    required: true
  },
  bizbankEnabled: {
    required: true
  }
});
Builder.createAndAttachToType(DeactivateCardResponse);
/**
 * SOURCE FinishCardActivationRequest @ squareup/bizbank/service.proto at 208:1
 */
export const FinishCardActivationRequest = $root.lookupType('squareup.bizbank.service.FinishCardActivationRequest');
fixType(FinishCardActivationRequest);
Builder.createAndAttachToType(FinishCardActivationRequest);
/**
 * SOURCE FinishCardActivationResponse @ squareup/bizbank/service.proto at 220:1
 */
export const FinishCardActivationResponse = $root.lookupType('squareup.bizbank.service.FinishCardActivationResponse');
fixType(FinishCardActivationResponse, {
  result: {
    required: true
  }
});
Builder.createAndAttachToType(FinishCardActivationResponse);
/**
 * SOURCE Result @ squareup/bizbank/service.proto at 225:3
 */
FinishCardActivationResponse.Result = $root.lookupEnum('squareup.bizbank.service.FinishCardActivationResponse.Result').values;
/**
 * SOURCE GetBalanceRequest @ squareup/bizbank/service.proto at 242:1
 */
export const GetBalanceRequest = $root.lookupType('squareup.bizbank.service.GetBalanceRequest');
fixType(GetBalanceRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetBalanceRequest);
/**
 * SOURCE GetBalanceResponse @ squareup/bizbank/service.proto at 246:1
 */
export const GetBalanceResponse = $root.lookupType('squareup.bizbank.service.GetBalanceResponse');
fixType(GetBalanceResponse, {
  balance: {
    required: true
  },
  maxInstantDepositAmount: {
    required: true
  }
});
Builder.createAndAttachToType(GetBalanceResponse);
/**
 * SOURCE GetCardActivityRequest @ squareup/bizbank/service.proto at 318:1
 */
export const GetCardActivityRequest = $root.lookupType('squareup.bizbank.service.GetCardActivityRequest');
fixType(GetCardActivityRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetCardActivityRequest);
/**
 * SOURCE Filters @ squareup/bizbank/service.proto at 322:3
 */
GetCardActivityRequest.Filters = $root.lookupType('squareup.bizbank.service.GetCardActivityRequest.Filters');
fixType(GetCardActivityRequest.Filters);
Builder.createAndAttachToType(GetCardActivityRequest.Filters);
/**
 * SOURCE DateSource @ squareup/bizbank/service.proto at 323:5
 */
GetCardActivityRequest.Filters.DateSource = $root.lookupEnum('squareup.bizbank.service.GetCardActivityRequest.Filters.DateSource').values;
/**
 * SOURCE GetCardActivityResponse @ squareup/bizbank/service.proto at 353:1
 */
export const GetCardActivityResponse = $root.lookupType('squareup.bizbank.service.GetCardActivityResponse');
fixType(GetCardActivityResponse, {
  batchResponse: {
    required: true
  }
});
Builder.createAndAttachToType(GetCardActivityResponse);
/**
 * SOURCE BatchResponse @ squareup/bizbank/service.proto at 354:3
 */
GetCardActivityResponse.BatchResponse = $root.lookupType('squareup.bizbank.service.GetCardActivityResponse.BatchResponse');
fixType(GetCardActivityResponse.BatchResponse);
Builder.createAndAttachToType(GetCardActivityResponse.BatchResponse);
/**
 * SOURCE GetCardCustomizationRequest @ squareup/bizbank/service.proto at 385:1
 */
export const GetCardCustomizationRequest = $root.lookupType('squareup.bizbank.service.GetCardCustomizationRequest');
fixType(GetCardCustomizationRequest);
Builder.createAndAttachToType(GetCardCustomizationRequest);
/**
 * SOURCE CardCustomization @ squareup/bizbank/service.proto at 392:1
 */
export const CardCustomization = $root.lookupType('squareup.bizbank.service.CardCustomization');
fixType(CardCustomization);
Builder.createAndAttachToType(CardCustomization);
/**
 * SOURCE GetCardCustomizationResponse @ squareup/bizbank/service.proto at 397:1
 */
export const GetCardCustomizationResponse = $root.lookupType('squareup.bizbank.service.GetCardCustomizationResponse');
fixType(GetCardCustomizationResponse, {
  success: {
    required: true
  }
});
Builder.createAndAttachToType(GetCardCustomizationResponse);
/**
 * SOURCE GetCardBillingAddressRequest @ squareup/bizbank/service.proto at 431:1
 */
export const GetCardBillingAddressRequest = $root.lookupType('squareup.bizbank.service.GetCardBillingAddressRequest');
fixType(GetCardBillingAddressRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetCardBillingAddressRequest);
/**
 * SOURCE GetCardBillingAddressResponse @ squareup/bizbank/service.proto at 435:1
 */
export const GetCardBillingAddressResponse = $root.lookupType('squareup.bizbank.service.GetCardBillingAddressResponse');
fixType(GetCardBillingAddressResponse);
Builder.createAndAttachToType(GetCardBillingAddressResponse);
/**
 * SOURCE ListCardsRequest @ squareup/bizbank/service.proto at 689:1
 */
export const ListCardsRequest = $root.lookupType('squareup.bizbank.service.ListCardsRequest');
fixType(ListCardsRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ListCardsRequest);
/**
 * SOURCE SortOrder @ squareup/bizbank/service.proto at 690:3
 */
ListCardsRequest.SortOrder = $root.lookupEnum('squareup.bizbank.service.ListCardsRequest.SortOrder').values;
/**
 * SOURCE Filters @ squareup/bizbank/service.proto at 697:3
 */
ListCardsRequest.Filters = $root.lookupType('squareup.bizbank.service.ListCardsRequest.Filters');
fixType(ListCardsRequest.Filters);
Builder.createAndAttachToType(ListCardsRequest.Filters);
/**
 * SOURCE ListCardsResponse @ squareup/bizbank/service.proto at 709:1
 */
export const ListCardsResponse = $root.lookupType('squareup.bizbank.service.ListCardsResponse');
fixType(ListCardsResponse);
Builder.createAndAttachToType(ListCardsResponse);
/**
 * SOURCE CardBrand @ squareup/bizbank/service.proto at 713:1
 */
export const CardBrand = $root.lookupEnum('squareup.bizbank.service.CardBrand').values;
/**
 * SOURCE CardData @ squareup/bizbank/service.proto at 718:1
 */
export const CardData = $root.lookupType('squareup.bizbank.service.CardData');
fixType(CardData, {
  cardState: {
    required: true
  },
  cardBrand: {
    required: true
  },
  cardType: {
    required: true
  }
});
Builder.createAndAttachToType(CardData);
/**
 * SOURCE CardState @ squareup/bizbank/service.proto at 750:3
 */
CardData.CardState = $root.lookupEnum('squareup.bizbank.service.CardData.CardState').values;
/**
 * SOURCE CardType @ squareup/bizbank/service.proto at 770:3
 */
CardData.CardType = $root.lookupEnum('squareup.bizbank.service.CardData.CardType').values;
/**
 * SOURCE CardActivity @ squareup/bizbank/service.proto at 796:1
 */
export const CardActivity = $root.lookupType('squareup.bizbank.service.CardActivity');
fixType(CardActivity, {
  transactionToken: {
    required: true
  },
  amount: {
    required: true
  },
  description: {
    required: true
  },
  activityType: {
    required: true
  },
  transactionState: {
    required: true
  },
  occurredAt: {
    required: true
  }
});
Builder.createAndAttachToType(CardActivity);
/**
 * SOURCE ActivityType @ squareup/bizbank/service.proto at 797:3
 */
CardActivity.ActivityType = $root.lookupEnum('squareup.bizbank.service.CardActivity.ActivityType').values;
/**
 * SOURCE DepositCardInfo @ squareup/bizbank/service.proto at 818:3
 */
CardActivity.DepositCardInfo = $root.lookupType('squareup.bizbank.service.CardActivity.DepositCardInfo');
fixType(CardActivity.DepositCardInfo);
Builder.createAndAttachToType(CardActivity.DepositCardInfo);
/**
 * SOURCE DepositBankInfo @ squareup/bizbank/service.proto at 825:3
 */
CardActivity.DepositBankInfo = $root.lookupType('squareup.bizbank.service.CardActivity.DepositBankInfo');
fixType(CardActivity.DepositBankInfo);
Builder.createAndAttachToType(CardActivity.DepositBankInfo);
/**
 * SOURCE ProvideFeedbackRequest @ squareup/bizbank/service.proto at 849:1
 */
export const ProvideFeedbackRequest = $root.lookupType('squareup.bizbank.service.ProvideFeedbackRequest');
fixType(ProvideFeedbackRequest, {
  idempotenceKey: {
    notEmpty: true
  },
  unitToken: {
    notEmpty: true
  },
  feedbackText: {
    notEmpty: true
  },
  feedbackSource: {
    required: true
  }
});
Builder.createAndAttachToType(ProvideFeedbackRequest);
/**
 * SOURCE FeedbackSource @ squareup/bizbank/service.proto at 855:3
 */
ProvideFeedbackRequest.FeedbackSource = $root.lookupEnum('squareup.bizbank.service.ProvideFeedbackRequest.FeedbackSource').values;
/**
 * SOURCE ProvideFeedbackResponse @ squareup/bizbank/service.proto at 960:1
 */
export const ProvideFeedbackResponse = $root.lookupType('squareup.bizbank.service.ProvideFeedbackResponse');
fixType(ProvideFeedbackResponse, {
  success: {
    required: true
  }
});
Builder.createAndAttachToType(ProvideFeedbackResponse);
/**
 * SOURCE SetCardBillingAddressRequest @ squareup/bizbank/service.proto at 972:1
 */
export const SetCardBillingAddressRequest = $root.lookupType('squareup.bizbank.service.SetCardBillingAddressRequest');
fixType(SetCardBillingAddressRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(SetCardBillingAddressRequest);
/**
 * SOURCE SetCardBillingAddressResponse @ squareup/bizbank/service.proto at 977:1
 */
export const SetCardBillingAddressResponse = $root.lookupType('squareup.bizbank.service.SetCardBillingAddressResponse');
fixType(SetCardBillingAddressResponse);
Builder.createAndAttachToType(SetCardBillingAddressResponse);
/**
 * SOURCE SetEnabledRequest @ squareup/bizbank/service.proto at 981:1
 */
export const SetEnabledRequest = $root.lookupType('squareup.bizbank.service.SetEnabledRequest');
fixType(SetEnabledRequest, {
  unitToken: {
    notEmpty: true
  },
  enabled: {
    required: true
  }
});
Builder.createAndAttachToType(SetEnabledRequest);
/**
 * SOURCE SetEnabledResponse @ squareup/bizbank/service.proto at 986:1
 */
export const SetEnabledResponse = $root.lookupType('squareup.bizbank.service.SetEnabledResponse');
fixType(SetEnabledResponse, {
  success: {
    required: true
  }
});
Builder.createAndAttachToType(SetEnabledResponse);
/**
 * SOURCE SetPasscodeRequest @ squareup/bizbank/service.proto at 990:1
 */
export const SetPasscodeRequest = $root.lookupType('squareup.bizbank.service.SetPasscodeRequest');
fixType(SetPasscodeRequest, {
  passcode: {
    notEmpty: true
  },
  cardToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(SetPasscodeRequest);
/**
 * SOURCE SetPasscodeResponse @ squareup/bizbank/service.proto at 999:1
 */
export const SetPasscodeResponse = $root.lookupType('squareup.bizbank.service.SetPasscodeResponse');
fixType(SetPasscodeResponse, {
  result: {
    required: true
  }
});
Builder.createAndAttachToType(SetPasscodeResponse);
/**
 * SOURCE Result @ squareup/bizbank/service.proto at 1002:3
 */
SetPasscodeResponse.Result = $root.lookupEnum('squareup.bizbank.service.SetPasscodeResponse.Result').values;
/**
 * SOURCE StartCardActivationRequest @ squareup/bizbank/service.proto at 1012:1
 */
export const StartCardActivationRequest = $root.lookupType('squareup.bizbank.service.StartCardActivationRequest');
fixType(StartCardActivationRequest, {
  unitToken: {
    notEmpty: true
  },
  cardToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(StartCardActivationRequest);
/**
 * SOURCE StartCardActivationResponse @ squareup/bizbank/service.proto at 1021:1
 */
export const StartCardActivationResponse = $root.lookupType('squareup.bizbank.service.StartCardActivationResponse');
fixType(StartCardActivationResponse, {
  success: {
    required: true
  }
});
Builder.createAndAttachToType(StartCardActivationResponse);
/**
 * SOURCE StartIdentityVerificationRequest @ squareup/bizbank/service.proto at 1026:1
 */
export const StartIdentityVerificationRequest = $root.lookupType('squareup.bizbank.service.StartIdentityVerificationRequest');
fixType(StartIdentityVerificationRequest, {
  unitToken: {
    required: true
  }
});
Builder.createAndAttachToType(StartIdentityVerificationRequest);
/**
 * SOURCE StartIdentityVerificationResponse @ squareup/bizbank/service.proto at 1033:1
 */
export const StartIdentityVerificationResponse = $root.lookupType('squareup.bizbank.service.StartIdentityVerificationResponse');
fixType(StartIdentityVerificationResponse);
Builder.createAndAttachToType(StartIdentityVerificationResponse);
/**
 * SOURCE StartIssueCardRequest @ squareup/bizbank/service.proto at 1037:1
 */
export const StartIssueCardRequest = $root.lookupType('squareup.bizbank.service.StartIssueCardRequest');
fixType(StartIssueCardRequest, {
  unitToken: {
    notEmpty: true
  },
  shippingAddress: {
    required: true
  }
});
Builder.createAndAttachToType(StartIssueCardRequest);
/**
 * SOURCE StartIssueCardResponse @ squareup/bizbank/service.proto at 1042:1
 */
export const StartIssueCardResponse = $root.lookupType('squareup.bizbank.service.StartIssueCardResponse');
fixType(StartIssueCardResponse, {
  success: {
    required: true
  }
});
Builder.createAndAttachToType(StartIssueCardResponse);
/**
 * SOURCE AddressNormalizationResult @ squareup/bizbank/service.proto at 1052:3
 */
StartIssueCardResponse.AddressNormalizationResult = $root.lookupEnum('squareup.bizbank.service.StartIssueCardResponse.AddressNormalizationResult').values;
/**
 * SOURCE TwoFactorAuthenticationRequestType @ squareup/bizbank/service.proto at 1060:1
 */
export const TwoFactorAuthenticationRequestType = $root.lookupEnum('squareup.bizbank.service.TwoFactorAuthenticationRequestType').values;
/**
 * SOURCE StartTwoFactorAuthenticationRequest @ squareup/bizbank/service.proto at 1068:1
 */
export const StartTwoFactorAuthenticationRequest = $root.lookupType('squareup.bizbank.service.StartTwoFactorAuthenticationRequest');
fixType(StartTwoFactorAuthenticationRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(StartTwoFactorAuthenticationRequest);
/**
 * SOURCE StartTwoFactorAuthenticationResponse @ squareup/bizbank/service.proto at 1077:1
 */
export const StartTwoFactorAuthenticationResponse = $root.lookupType('squareup.bizbank.service.StartTwoFactorAuthenticationResponse');
fixType(StartTwoFactorAuthenticationResponse, {
  success: {
    required: true
  }
});
Builder.createAndAttachToType(StartTwoFactorAuthenticationResponse);
/**
 * SOURCE ToggleCardRequest @ squareup/bizbank/service.proto at 1081:1
 */
export const ToggleCardRequest = $root.lookupType('squareup.bizbank.service.ToggleCardRequest');
fixType(ToggleCardRequest, {
  unitToken: {
    notEmpty: true
  },
  cardToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ToggleCardRequest);
/**
 * SOURCE ToggleCardResponse @ squareup/bizbank/service.proto at 1088:1
 */
export const ToggleCardResponse = $root.lookupType('squareup.bizbank.service.ToggleCardResponse');
fixType(ToggleCardResponse);
Builder.createAndAttachToType(ToggleCardResponse);
/**
 * SOURCE VerifyCardActivationTokenRequest @ squareup/bizbank/service.proto at 1094:1
 */
export const VerifyCardActivationTokenRequest = $root.lookupType('squareup.bizbank.service.VerifyCardActivationTokenRequest');
fixType(VerifyCardActivationTokenRequest, {
  activationToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(VerifyCardActivationTokenRequest);
/**
 * SOURCE VerifyCardActivationTokenResponse @ squareup/bizbank/service.proto at 1101:1
 */
export const VerifyCardActivationTokenResponse = $root.lookupType('squareup.bizbank.service.VerifyCardActivationTokenResponse');
fixType(VerifyCardActivationTokenResponse, {
  result: {
    required: true
  }
});
Builder.createAndAttachToType(VerifyCardActivationTokenResponse);
/**
 * SOURCE Result @ squareup/bizbank/service.proto at 1107:3
 */
VerifyCardActivationTokenResponse.Result = $root.lookupEnum('squareup.bizbank.service.VerifyCardActivationTokenResponse.Result').values;
/**
 * SOURCE VerifyTwoFactorAuthenticationTokenRequest @ squareup/bizbank/service.proto at 1116:1
 */
export const VerifyTwoFactorAuthenticationTokenRequest = $root.lookupType('squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenRequest');
fixType(VerifyTwoFactorAuthenticationTokenRequest, {
  authenticationToken: {
    notEmpty: true
  },
  requestType: {
    required: true
  }
});
Builder.createAndAttachToType(VerifyTwoFactorAuthenticationTokenRequest);
/**
 * SOURCE VerifyTwoFactorAuthenticationTokenResponse @ squareup/bizbank/service.proto at 1122:1
 */
export const VerifyTwoFactorAuthenticationTokenResponse = $root.lookupType('squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenResponse');
fixType(VerifyTwoFactorAuthenticationTokenResponse, {
  result: {
    required: true
  }
});
Builder.createAndAttachToType(VerifyTwoFactorAuthenticationTokenResponse);
/**
 * SOURCE Result @ squareup/bizbank/service.proto at 1128:3
 */
VerifyTwoFactorAuthenticationTokenResponse.Result = $root.lookupEnum('squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenResponse.Result').values;
/**
 * SOURCE IdvState @ squareup/bizbank/service.proto at 1143:1
 */
export const IdvState = $root.lookupEnum('squareup.bizbank.service.IdvState').values;
/**
 * SOURCE ValidateAddressRequest @ squareup/bizbank/service.proto at 1285:1
 */
export const ValidateAddressRequest = $root.lookupType('squareup.bizbank.service.ValidateAddressRequest');
fixType(ValidateAddressRequest, {
  address: {
    required: true
  }
});
Builder.createAndAttachToType(ValidateAddressRequest);
/**
 * SOURCE ValidateAddressResponse @ squareup/bizbank/service.proto at 1289:1
 */
export const ValidateAddressResponse = $root.lookupType('squareup.bizbank.service.ValidateAddressResponse');
fixType(ValidateAddressResponse);
Builder.createAndAttachToType(ValidateAddressResponse);
/**
 * SOURCE CorrectedField @ squareup/bizbank/service.proto at 1290:3
 */
ValidateAddressResponse.CorrectedField = $root.lookupEnum('squareup.bizbank.service.ValidateAddressResponse.CorrectedField').values;
/**
 * SOURCE AddressNormalizationResult @ squareup/bizbank/service.proto at 1299:3
 */
ValidateAddressResponse.AddressNormalizationResult = $root.lookupEnum('squareup.bizbank.service.ValidateAddressResponse.AddressNormalizationResult').values;
/**
 * SOURCE GetCustomizationSettingsRequest @ squareup/bizbank/service.proto at 2049:1
 */
export const GetCustomizationSettingsRequest = $root.lookupType('squareup.bizbank.service.GetCustomizationSettingsRequest');
fixType(GetCustomizationSettingsRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetCustomizationSettingsRequest);
/**
 * SOURCE GetCustomizationSettingsResponse @ squareup/bizbank/service.proto at 2055:1
 */
export const GetCustomizationSettingsResponse = $root.lookupType('squareup.bizbank.service.GetCustomizationSettingsResponse');
fixType(GetCustomizationSettingsResponse, {
  success: {
    required: true
  }
});
Builder.createAndAttachToType(GetCustomizationSettingsResponse);
/**
 * SOURCE IneligibilityReason @ squareup/bizbank/service.proto at 2080:3
 */
GetCustomizationSettingsResponse.IneligibilityReason = $root.lookupEnum('squareup.bizbank.service.GetCustomizationSettingsResponse.IneligibilityReason').values;
/**
 * SOURCE ExistingCustomization @ squareup/bizbank/service.proto at 2089:3
 */
GetCustomizationSettingsResponse.ExistingCustomization = $root.lookupType('squareup.bizbank.service.GetCustomizationSettingsResponse.ExistingCustomization');
fixType(GetCustomizationSettingsResponse.ExistingCustomization);
Builder.createAndAttachToType(GetCustomizationSettingsResponse.ExistingCustomization);
/**
 * SOURCE GetAllStampsRequest @ squareup/bizbank/service.proto at 2096:1
 */
export const GetAllStampsRequest = $root.lookupType('squareup.bizbank.service.GetAllStampsRequest');
fixType(GetAllStampsRequest);
Builder.createAndAttachToType(GetAllStampsRequest);
/**
 * This is a similar object from Franklin since we will be using their drawing tool
 *
 * SOURCE GetAllStampsResponse @ squareup/bizbank/service.proto at 2099:1
 */
export const GetAllStampsResponse = $root.lookupType('squareup.bizbank.service.GetAllStampsResponse');
fixType(GetAllStampsResponse);
Builder.createAndAttachToType(GetAllStampsResponse);
/**
 * SOURCE Stamp @ squareup/bizbank/service.proto at 2103:1
 */
export const Stamp = $root.lookupType('squareup.bizbank.service.Stamp');
fixType(Stamp);
Builder.createAndAttachToType(Stamp);
/**
 * Hack Week 2024 q2
 *
 * SOURCE MerchantBlockState @ squareup/bizbank/service.proto at 2290:1
 */
export const MerchantBlockState = $root.lookupEnum('squareup.bizbank.service.MerchantBlockState').values;
/**
 * Update the block state given a unit token/merchantein merchant
 *
 * SOURCE UpdateMerchantBlockRequest @ squareup/bizbank/service.proto at 2297:1
 */
export const UpdateMerchantBlockRequest = $root.lookupType('squareup.bizbank.service.UpdateMerchantBlockRequest');
fixType(UpdateMerchantBlockRequest, {
  merchanteinMerchantToken: {
    notEmpty: true
  },
  unitToken: {
    notEmpty: true
  },
  merchantBlockState: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateMerchantBlockRequest);
/**
 * SOURCE UpdateMerchantBlockResponse @ squareup/bizbank/service.proto at 2304:1
 */
export const UpdateMerchantBlockResponse = $root.lookupType('squareup.bizbank.service.UpdateMerchantBlockResponse');
fixType(UpdateMerchantBlockResponse, {
  merchantBlockState: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateMerchantBlockResponse);
/**
 * Get the current block state for a unit token/merchantein merchant
 *
 * SOURCE GetMerchantBlockRequest @ squareup/bizbank/service.proto at 2309:1
 */
export const GetMerchantBlockRequest = $root.lookupType('squareup.bizbank.service.GetMerchantBlockRequest');
fixType(GetMerchantBlockRequest, {
  merchanteinMerchantToken: {
    notEmpty: true
  },
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetMerchantBlockRequest);
/**
 * SOURCE GetMerchantBlockResponse @ squareup/bizbank/service.proto at 2315:1
 */
export const GetMerchantBlockResponse = $root.lookupType('squareup.bizbank.service.GetMerchantBlockResponse');
fixType(GetMerchantBlockResponse, {
  merchantBlockState: {
    required: true
  }
});
Builder.createAndAttachToType(GetMerchantBlockResponse);
/**
 * List all the blocked merchantein merchants for a given unit token
 *
 * SOURCE ListMerchantBlocksRequest @ squareup/bizbank/service.proto at 2320:1
 */
export const ListMerchantBlocksRequest = $root.lookupType('squareup.bizbank.service.ListMerchantBlocksRequest');
fixType(ListMerchantBlocksRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ListMerchantBlocksRequest);
/**
 * SOURCE ListMerchantBlocksResponse @ squareup/bizbank/service.proto at 2324:1
 */
export const ListMerchantBlocksResponse = $root.lookupType('squareup.bizbank.service.ListMerchantBlocksResponse');
fixType(ListMerchantBlocksResponse);
Builder.createAndAttachToType(ListMerchantBlocksResponse);
/**
 * SOURCE MerchanteinMerchant @ squareup/bizbank/service.proto at 2327:3
 */
ListMerchantBlocksResponse.MerchanteinMerchant = $root.lookupType('squareup.bizbank.service.ListMerchantBlocksResponse.MerchanteinMerchant');
fixType(ListMerchantBlocksResponse.MerchanteinMerchant, {
  token: {
    notEmpty: true
  },
  name: {
    notEmpty: true
  },
  merchantImage: {
    required: true
  }
});
Builder.createAndAttachToType(ListMerchantBlocksResponse.MerchanteinMerchant);